export const gameState = {
  loaded: false,
  active: true,
  started: false,
  waitingToStart: false,
  pauseMode: false,
  emulation: true,
  showGameOver: false,
  zoneIndex: 0,
  score: 0,
  dist: 0,
  tick: 0,
  accelDist: 200,
  accelTime: 0.06,
  nextCoin: 0,
  nextBonus: 0,
  nextTurret: 0,
  nextBird: 0,
  nextPickup: 0,
};